"use client";
import { jsx as s } from "react/jsx-runtime";
import { EmbeddedSearchPrimitive as a } from "@inkeep/cxkit-primitives";
import { cn as r } from "../utils.js";
import { citation as l } from "../ui/recipes/citation.js";
import { link as i } from "../ui/recipes/link.js";
import { scrollable as o } from "../ui/recipes/scrollable.js";
import { ResultsLoading as n } from "./embedded-search/results-loading.js";
import { merge as m } from "merge-anything";
import { markdownStyles as c } from "../ui/markdown-styles.js";
const f = (e) => /* @__PURE__ */ s(a.Provider, { ...e }), k = ({ className: e, ...t }) => /* @__PURE__ */ s(
  a.Wrapper,
  {
    className: r(
      "data-[hidden]:hidden rounded-md flex",
      "bg-white dark:bg-gray-dark-950",
      e
    ),
    ...t
  }
), v = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.Root,
  {
    className: r(
      "data-[hidden]:hidden flex flex-col w-full",
      "[--footer-height:theme(spacing.9)]",
      "data-[mobile]:[--input-height:theme(spacing.16)]",
      "[--ask-ai-trigger-height:0px]",
      "[[data-show-ask-ai-card]_&]:[--ask-ai-trigger-height:theme(spacing.11)]",
      e
    ),
    ...t
  }
), S = a.Content, y = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.InputGroup,
  {
    className: r(
      "flex items-center w-full px-5 pt-3 pb-3 gap-3",
      "[[data-show-ask-ai-card]_&]:pb-1",
      "[[data-mobile]_&]:max-h-[var(--input-height)]",
      e
    ),
    ...t
  }
), E = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.InputIcon,
  {
    className: r("min-w-5 w-5 text-xl", "text-gray-500 dark:text-white-alpha-600", e),
    ...t
  }
), T = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.Input,
  {
    className: r(
      "min-h-[38px] overflow-hidden w-full resize-none",
      "py-1.5 max-h-[10vh] placeholder:text-gray-500",
      "w-full dark:placeholder:text-gray-dark-200",
      "border-none outline-none shadow-none bg-transparent",
      e
    ),
    ...t
  }
), N = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.Loading,
  {
    className: r("animate-spin text-gray-400 dark:text-white-alpha-500", e),
    ...t
  }
), P = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.AskAITrigger,
  {
    className: r(
      l({ slot: "root" }),
      "m-auto w-[calc(100%_-_theme(spacing.5))]",
      "border-transparent dark:border-transparent",
      "mb-3 py-0 h-11 cursor-pointer",
      "h-[var(--ask-ai-trigger-height)]",
      e
    ),
    ...t
  }
), A = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.AskAITriggerIcon,
  {
    className: r(
      "[grid-area:icon] h-5 w-5",
      "[--start-color:theme(colors.inkeep-expanded-primary.300)]",
      "[--end-color:theme(colors.inkeep-expanded-primary.700)]",
      "dark:[--start-color:theme(colors.inkeep-expanded-primary.50)]",
      "dark:[--end-color:theme(colors.inkeep-expanded-primary.300)]",
      e
    ),
    ...t
  }
), L = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.AskAITriggerLabel,
  {
    className: r(l({ slot: "title" }), "font-normal", e),
    ...t
  }
), _ = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.AskAITriggerIndicator,
  {
    className: r(l({ slot: "indicator" }), e),
    ...t
  }
), O = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.Results,
  {
    className: r(
      o({ section: "content" }),
      "h-0 max-h-full",
      "data-[has-content]:h-[min(calc(85vh_-_72px),calc(850px_-_72px_-_275px))]",
      "md:data-[dual-pane-search-expanded]:h-[min(calc(85vh_-_72px),calc(900px_-_72px_-_135px))]",
      "[[data-mobile]_&]:h-[calc(100vh-var(--input-height)-var(--footer-height)-var(--ask-ai-trigger-height))]",
      "transition-all duration-300 ease-in-out data-[has-content]:pb-2",
      e
    ),
    ...t
  }
), B = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ResultsLoading,
  {
    className: r("group mb-1 relative transition-all w-full h-full", e),
    children: /* @__PURE__ */ s(n, {}),
    ...t
  }
), C = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ResultsEmpty,
  {
    className: r(
      "flex w-full h-full",
      "overflow-hidden relative grow-[2]",
      "items-center justify-center text-gray-600",
      "dark:text-gray-dark-400 mt-8",
      e
    ),
    ...t
  }
), D = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ResultsTabList,
  {
    className: r(
      "shrink-0 max-w-full",
      "flex gap-3 px-5 py-1",
      "overflow-x-auto [scrollbar-width:thin]",
      e
    ),
    ...t
  }
), H = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ResultsTab,
  {
    className: r(
      "px-3 text-1sm font-medium rounded-full shrink-0",
      "py-1 transition-all duration-200 leading-snug",
      "border border-gray-300 dark:border-gray-dark-500",
      "hover:bg-gray-50 dark:hover:bg-white-alpha-50",
      "data-[state=active]:bg-inkeep-primary-light-subtle",
      "hover:data-[state=active]:bg-inkeep-primary-light-subtle",
      "data-[state=active]:text-inkeep-expanded-primary-900",
      "data-[state=active]:border-inkeep-primary-medium-subtle",
      "dark:data-[state=active]:bg-white-alpha-100",
      "dark:hover:data-[state=active]:bg-white-alpha-100",
      "dark:data-[state=active]:text-inkeep-expanded-primary-300",
      "dark:data-[state=active]:border-inkeep-expanded-primary-300",
      "focus:outline-inkeep-expanded-primary-700 dark:focus:outline-inkeep-expanded-primary-300",
      e
    ),
    ...t
  }
), j = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ResultsContent,
  {
    className: r("flex overflow-hidden h-full", e),
    ...t
  }
), F = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ResultsScrollArea,
  {
    className: r(
      "overflow-hidden h-full",
      // Dual pane
      "first:[[data-view=dual-pane]_&]:flex-1 md:first:[[data-view=dual-pane]_&]:flex-[0_0_40%]",
      // Fade shadows
      'befter:content-[""] befter:absolute befter:inset-x-0',
      "befter:h-10 befter:pointer-events-none",
      "befter:transition-opacity befter:duration-300",
      "befter:ease-in-out befter:from-white",
      "befter:dark:from-gray-dark-950 befter:to-transparent",
      "before:top-0 after:bottom-0",
      "before:bg-gradient-to-b after:bg-gradient-to-t",
      "has-[[data-scroll-top]]:before:opacity-0",
      "has-[[data-scroll-bottom]]:after:opacity-0",
      e
    ),
    ...t
  }
), G = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ResultsScrollAreaViewport,
  {
    className: r("h-full w-full rounded-[inherit]", e),
    ...t
  }
), V = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ResultsScrollAreaScrollbar,
  {
    className: r(
      "flex select-none touch-none p-0.5",
      "transition-colors duration-[160ms] ease-in-out",
      "w-2.5 border-l border-l-transparent",
      e
    ),
    ...t
  }
), W = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ResultsScrollAreaThumb,
  {
    className: r("relative flex-1 rounded-full", "bg-gray-300 dark:bg-white-alpha-200", e),
    ...t
  }
), z = a.ResultsScrollAreaCorner, $ = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ResultsList,
  {
    className: r(
      "w-full flex flex-col",
      "items-center gap-2.5 h-full shrink-0",
      "px-5 py-1 content-center -my-[1px]",
      e
    ),
    ...t
  }
), q = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ResultsItem,
  {
    className: r(l({ slot: "root" }), e),
    ...t
  }
), J = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ResultsItemBreadcrumbs,
  {
    className: r(l({ slot: "breadcrumbs" }), e),
    ...t
  }
), K = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ResultsItemBreadcrumbIcon,
  {
    className: r(l({ slot: "breadcrumbsIcon" }), e),
    ...t
  }
), M = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ResultsItemIcon,
  {
    className: r(l({ slot: "icon" }), e),
    ...t
  }
), Q = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ResultsItemTitle,
  {
    className: r(l({ slot: "title" }), e),
    ...t
  }
), U = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ResultsItemTag,
  {
    className: r(l({ slot: "tag" }), e),
    ...t
  }
), X = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ResultsItemDescription,
  {
    className: r(l({ slot: "description" }), e),
    ...t
  }
), Y = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ResultsItemDescriptionPart,
  {
    className: r(l({ slot: "descriptionPart" }), e),
    ...t
  }
), Z = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ResultsItemIndicator,
  {
    className: r(l({ slot: "indicator" }), e),
    ...t
  }
), ee = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ResultsItemPreview,
  {
    className: r(
      "flex-1 min-w-0 break-words py-4 pr-12 pl-8",
      "hidden md:flex flex-col gap-6",
      e
    ),
    ...t
  }
), te = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ResultsItemPreviewHeader,
  {
    className: r("flex flex-col gap-5", e),
    ...t
  }
), ae = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ResultsItemPreviewHeading,
  {
    className: r("inline-block", e),
    ...t
  }
), se = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ResultsItemPreviewTitle,
  {
    className: r(
      "text-3xl leading-snug tracking-tight",
      "font-semibold hover:text-inkeep-primary-stronger",
      "dark:hover:text-inkeep-expanded-primary-100",
      e
    ),
    ...t
  }
), re = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ResultsItemPreviewTitleLinkIcon,
  {
    className: r(
      "inline-block ml-2 mb-2 tracking-tight text-gray-500 dark:text-white-alpha-500",
      e
    ),
    ...t
  }
), le = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ResultsItemPreviewBreadcrumbs,
  {
    className: r(
      l({ slot: "breadcrumbs" }),
      "!line-clamp-none whitespace-normal text-gray-500 dark:text-gray-dark-200 text-sm",
      e
    ),
    ...t
  }
), de = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ResultsItemPreviewBreadcrumbIcon,
  {
    className: r(l({ slot: "breadcrumbsIcon" }), e),
    ...t
  }
), ie = ({
  className: e,
  componentStyles: t,
  ...d
}) => /* @__PURE__ */ s(
  a.ResultsItemPreviewBody,
  {
    className: r(
      "max-w-full text-gray-700 dark:text-gray-dark-100 [&_em]:font-bold [&_em]:not-italic",
      e
    ),
    componentStyles: m(c, t ?? {}),
    ...d
  }
), oe = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ResultsItemPreviewOutline,
  {
    className: r("flex flex-col gap-3", e),
    ...t
  }
), ne = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ResultsItemPreviewOutlineTitle,
  {
    className: r(
      "text-xs uppercase font-semibold tracking-widest",
      "text-gray-500 dark:text-white-alpha-500",
      e
    ),
    ...t
  }
), me = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ResultsItemPreviewOutlineList,
  {
    className: r("flex flex-col gap-4", e),
    ...t
  }
), ce = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ResultsItemPreviewOutlineItem,
  {
    className: r(
      "flex items-center gap-1 text-gray-600 dark:text-white-alpha-600 font-medium ",
      `${t.href ? "cursor-pointer hover:text-gray-800 dark:hover:text-white-alpha-800 dark:data-[is-match]:hover:text-inkeep-expanded-primary-200 data-[is-match]:hover:text-inkeep-expanded-primary-800 " : ""}`,
      "data-[is-match]:text-inkeep-expanded-primary-700",
      "dark:data-[is-match]:text-inkeep-expanded-primary-300",
      e
    ),
    ...t
  }
), ue = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(a.ResultsItemPreviewOutlineItemIcon, { className: r(e), ...t }), he = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(a.ResultsItemPreviewOutlineItemText, { className: r(e), ...t }), pe = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.ResultsItemPreviewOutlineItemLinkIcon,
  {
    className: r("h-3 !min-h-0 !min-w-0", e),
    ...t
  }
), be = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.Footer,
  {
    className: r(
      "justify-self-end",
      "px-5 pt-1 pb-3",
      "[[data-mobile]_&]:py-0",
      "[[data-mobile]_&]:items-center",
      "[[data-mobile]_&]:h-[var(--footer-height)]",
      "hidden data-[has-results]:flex",
      e
    ),
    ...t
  }
), ge = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.TaglineContainer,
  {
    className: r("flex items-center whitespace-nowrap", e),
    ...t
  }
), Ie = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.TaglineText,
  {
    className: r("text-xs md:text-sm text-gray-500 dark:text-white-alpha-600", e),
    ...t
  }
), xe = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.TaglineLogo,
  {
    className: r("text-gray-400 dark:text-white-alpha-500", "w-[18px] ml-2 mr-1", e),
    ...t
  }
), Re = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  a.TaglineBrandName,
  {
    className: r(
      i(),
      "inline-flex text-xs md:text-sm text-gray-500",
      "dark:text-white-alpha-600 font-bold",
      e
    ),
    ...t
  }
);
export {
  P as AskAITrigger,
  A as AskAITriggerIcon,
  _ as AskAITriggerIndicator,
  L as AskAITriggerLabel,
  S as Content,
  be as Footer,
  T as Input,
  y as InputGroup,
  E as InputIcon,
  N as Loading,
  f as Provider,
  O as Results,
  j as ResultsContent,
  C as ResultsEmpty,
  q as ResultsItem,
  K as ResultsItemBreadcrumbIcon,
  J as ResultsItemBreadcrumbs,
  X as ResultsItemDescription,
  Y as ResultsItemDescriptionPart,
  M as ResultsItemIcon,
  Z as ResultsItemIndicator,
  ee as ResultsItemPreview,
  ie as ResultsItemPreviewBody,
  de as ResultsItemPreviewBreadcrumbIcon,
  le as ResultsItemPreviewBreadcrumbs,
  te as ResultsItemPreviewHeader,
  ae as ResultsItemPreviewHeading,
  oe as ResultsItemPreviewOutline,
  ce as ResultsItemPreviewOutlineItem,
  ue as ResultsItemPreviewOutlineItemIcon,
  pe as ResultsItemPreviewOutlineItemLinkIcon,
  he as ResultsItemPreviewOutlineItemText,
  me as ResultsItemPreviewOutlineList,
  ne as ResultsItemPreviewOutlineTitle,
  se as ResultsItemPreviewTitle,
  re as ResultsItemPreviewTitleLinkIcon,
  U as ResultsItemTag,
  Q as ResultsItemTitle,
  $ as ResultsList,
  B as ResultsLoading,
  F as ResultsScrollArea,
  z as ResultsScrollAreaCorner,
  V as ResultsScrollAreaScrollbar,
  W as ResultsScrollAreaThumb,
  G as ResultsScrollAreaViewport,
  H as ResultsTab,
  D as ResultsTabList,
  v as Root,
  Re as TaglineBrandName,
  ge as TaglineContainer,
  xe as TaglineLogo,
  Ie as TaglineText,
  k as Wrapper
};
